
export class CountryDetectionConstants {
    public static BROWSER_LANGUAGE_NONE: string = "";
    public static FLASHVAR_COUNTRY_NONE: string = "";
    public static INSTANCE_COUNTRY_DEFAULT: string = "default";
}
